import React from "react";
import gif from "../../assets/gif.gif";
import Button from "../Button";
import Main from '../Main/Main';

const Hero = () => {
	return (
		<div className="m-4 p-4 flex flex-col lg:grid grid-cols-2 place-items-center w-full gap-y-4">
			<div className="drop-shadow-2xl w-full">
				<img
					src={gif}
					className={`rounded-lg w-10/12 m-auto lg:w-full xl:w-10/12 2xl:w-6/12`}
					height="500"
					width="500"
					alt="nft gif"
				/>
			</div>
			<Main />
			{/* <div className=" flex flex-col place-items-center text-lg gap-y-4">
				<div className="flex flex-col gap-y-4 place-items-center">
					<h2 className="py-4 text-3xl font-bold uppercase">About Mōmoku</h2>
				</div>
				<div className="flex flex-col text-center gap-y-4 tracking-wide w-10/12 xl:text-2xl 2xl:text-3xl">
					<p>
						Mōmoku is a collection of 1444 NFTs, each representing a blinded warrior as a digitized
						piece of art. The Mōmoku collection is one of the most diverse and detailed on the NFT
						market with over 100 unique traits. Our goal is to build and develop a community around
						the hype of the anime universe.
					</p>
					<p>
						Although each warrior is blinded, that won't stop them from thriving in the darkness.
						The Mōmoku collection showcases anime and Japanese culture to the NFT market. Each of
						our characters are warriors who have evolved in the darkness and who have been digitized
						by talented and experienced artists to give them life in the Metaverse. Will you put on
						the blindfold and join the Mōmoku community?
					</p>
				</div>
				<Button text="MINT" onClick={""} classes="text-2xl" />
			</div> */}
		</div>
	);
};

export default Hero;
